import type { AnyAction } from '@reduxjs/toolkit'

export const isLegacyAction = (action: unknown): action is AnyAction =>
  typeof action === 'object' &&
  action !== null &&
  'type' in action &&
  typeof action.type === 'string'
